import { Injectable } from '@angular/core';
import { InMemoryCacheService } from 'src/app/common';


@Injectable()
export class ProjectResolver  {
  public constructor(private cache: InMemoryCacheService) {}

  public async resolve(): Promise<any> {
    this.cache.loading = true;

    try {
      const projectId = this.cache?.currentProject?.id;
      const organizationId = this.cache?.organization?.id;

      if (projectId && organizationId != null) {
        return await this.cache.getProjectByOrg(projectId, String(organizationId));
      }

      return await this.cache.getProject(this.cache?.currentProject?.id, this.cache?.currentProject?.userId);
    } finally {
      this.cache.loading = false;
    }
  }
}
